import React, { useMemo, useRef, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import InputItem from '../InputItem/InputItem';

import useOutsideClick from '../../../../util/useOutsideClick';

import searchIcon from '../../../../assets/images/icons/search.svg';
import './CustomSelect.scss';

const CustomSelect = ({
  options,
  selectedOption,
  setSelectedOption,
  defaultOption,
  icon,
  isPagination,
  showLabel,
  search = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const selectRef = useRef(null);
  const selectInput = useRef(null);

  const handleOptionSelect = (value) => {
    setSelectedOption(value);
    setIsOpen(false);
    setSearchQuery('');
  };

  const filteredOptions = useMemo(() => {
    if (!search || !searchQuery.trim()) return options;
    return options.filter((option) => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
  }, [options, search, searchQuery]);

  useOutsideClick(selectRef, selectInput, isOpen, () => {
    setIsOpen(false);
    setSearchQuery('');
  });

  return (
    <div className={`custom-select ${isOpen ? 'opened' : ''} ${isPagination ? 'pagination' : ''}`} ref={selectRef}>
      <div
        ref={selectInput}
        className={`selected-option ${selectedOption ? 'filled' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`selected-option__name ${defaultOption && !selectedOption ? 'default' : ''}`}>
          {icon && (
            <div className="input-icon">
              <img src={icon} />
            </div>
          )}
          {defaultOption && !selectedOption
            ? isOpen
              ? ''
              : defaultOption
            : options.find((option) => option.value == selectedOption)?.label}
        </span>
        {showLabel && <span className={`input-label ${selectedOption ? 'visible' : ''}`}>{defaultOption}</span>}
        <svg
          className={`arrow ${isOpen ? 'rotated' : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M6 10L12 16L18 10" stroke="#000000" strokeLinecap="round" />
        </svg>
      </div>
      {isOpen && (
        <div className={`options-wrapper n${filteredOptions.length} ${search ? 'search' : ''}`}>
          {search && (
            <InputItem
              type="text"
              icon={searchIcon}
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
            />
          )}
          {filteredOptions.length === 0 ? (
            <span className="no-data">No data</span>
          ) : (
            <PerfectScrollbar
              key={filteredOptions.length}
              options={{
                wheelPropagation: false,
                autoHide: false,
              }}
            >
              <ul className="options-list">
                {filteredOptions.map((option, index) => (
                  <li key={index} onClick={() => handleOptionSelect(option.value)} title={option.label}>
                    {option.label}
                  </li>
                ))}
              </ul>
            </PerfectScrollbar>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
